<template>
  <div class="message-button__wrapper">
    <popper trigger="clickToOpen" :options="{placement: 'right'}" ref="popover">
      <div class="popper message-button__popover-wrapper">
        <div class="message-button__popover-flex">
          <in
            v-model="newTitle"
            v-show="['account_link', 'account_unlink'].indexOf(newAction) === -1"
            class="message-button__popover-input"
            :label="$t('view.flow.blockElements.button.title') "
            maxlength="20"
          ></in>
          <sel
            v-model="newAction"
            class="message-button__popover-input"
            :label="$t('view.flow.blockElements.button.action') "
            @change="buttonTypeChange"
          >
            <option value="redirect">{{ $t('view.flow.blockElements.button.redirect') }}</option>
            <option value="url">{{ $t('view.flow.blockElements.button.openUrl') }}</option>
            <option value="postback">{{ $t('view.flow.blockElements.button.postback') }}</option>
            <option value="phone_number">{{ $t('view.flow.blockElements.button.call') }}</option>
            <option value="account_link">{{ $t('view.flow.blockElements.button.login') }}</option>
            <option value="account_unlink">{{ $t('view.flow.blockElements.button.logout') }}</option>
          </sel>
        </div>
        <div class="message-button__popover-data-editor">
          <in
            v-model="newUrl"
            class="message-button__popover-data-input"
            :label="$t('view.flow.blockElements.button.url')"
            v-show="newAction === 'url'"
          ></in>
          <in
            v-model="newPayload"
            class="message-button__popover-data-input"
            :label="$t('view.flow.blockElements.button.payload')"
            v-show="newAction === 'postback'"
          ></in>
          <in
            v-model="newPhoneNumber"
            class="message-button__popover-data-input"
            :label="$t('view.flow.blockElements.button.phoneNumber')"
            v-show="newAction === 'phone_number'"
          ></in>
          <in
            v-model="newLoginUrl"
            class="message-button__popover-data-input"
            :label="$t('view.flow.blockElements.button.url')"
            v-show="newAction === 'account_link'"
          ></in>
          <sel
            ref="targetRef"
            v-model="newTarget"
            class="message-button__popover-data-input"
            :label="$t('view.flow.blockElements.button.target')"
            v-show="newAction === 'redirect'"
            @input="setVars"
          >
            <option :value="''"></option>
            <optgroup v-for="group in groupedBlocks" :key="group.id" :label="group.name">
              <option
                v-for="block in group.blocks"
                :key="block.id"
                :value="block.uuid"
              >{{ block.name }}</option>
            </optgroup>
          </sel>
          <div v-show="newAction === 'url'" class="message-button__popover-flex">
            <sel
              v-model="newWebviewRatio"
              style="width: 75%;"
              class="message-button__popover-data-input"
              :label="$t('view.flow.blockElements.button.webviewRatio')"
            >
              <option value="compact">{{ $t('view.flow.blockElements.button.webviewRatioCompact') }}</option>
              <option value="tall">{{ $t('view.flow.blockElements.button.webviewRatioTall') }}</option>
              <option value="full">{{ $t('view.flow.blockElements.button.webviewRatioFull') }}</option>
            </sel>
            <sw-button
              v-model="newMessengerExtensions"
              :label="$t('view.flow.blockElements.button.messengerExtensions')"
            ></sw-button>
          </div>
          <in
            v-model="newFallbackUrl"
            class="message-button__popover-data-input"
            :label="$t('view.flow.blockElements.button.fallbackUrl')"
            v-show="newAction === 'url' && newMessengerExtensions"
          ></in>
        </div>

        <div class="message-button__vars">
          <sw-button
            v-if="blockVariables && Object.keys(blockVariables).length"
            v-model="button.data.passVariables"
            :label="$t('view.flow.blockElements.button.redirectVariables')"
          ></sw-button>

          <div class="message-button__vars-fields" v-if="button.data.passVariables">
            <div
              v-for="(field, k, i) in blockVariables"
              :key="i"
              class="message-button__vars-field"
            >
              <in
                v-if="field.type === 'number' || field.type === 'string'"
                :label="k"
                v-model="button.data.variables[k]"
              ></in>
              <sw-button v-else v-model="button.data.variables[k]" :label="k"></sw-button>
            </div>
          </div>
        </div>
        <div class="message-button__popover-buttons">
          <btn
            icon="trash"
            color="red"
            class="message-button__popover-button"
            @click="$emit('delete')"
            small
          >{{ $t('btn.delete') }}</btn>
          <btn
            icon="save"
            class="message-button__popover-button"
            @click="saveChanges"
            small
          >{{ $t('btn.save') }}</btn>
        </div>
      </div>

      <div
        class="message-button"
        :class="{'message-button--last': n === 2}"
        @click="preparePopover"
        slot="reference"
      >{{ button.text[$store.state.flowEditorLocale] }}</div>
    </popper>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    n: Number,
    cardParent: null,
    lastZIndex: Number
  },
  data() {
    return {
      groupedBlocks: {},
      newTitle: '', // Walk-around for popover bug
      newAction: '',
      newUrl: '',
      newTarget: '',
      newPayload: '',
      newPhoneNumber: '',
      newLoginUrl: '',
      newWebviewRatio: '',
      newMessengerExtensions: false,
      newFallbackUrl: '',
      button: {}
    }
  },
  methods: {
    preparePopover() {
      this.$forceUpdate()
      if (this.cardParent) this.cardParent.style.zIndex = (this.lastZIndex + 1).toString()
      this.groupedBlocks = this.$store.state.flowGroups
      this.newTitle = this.button.text[this.$store.state.flowEditorLocale]
      this.newAction = this.button.action
      this.newUrl = this.button.data.url || ''
      this.newTarget = this.button.data.target || ''
      this.newPayload = this.button.data.payload || ''
      this.newPhoneNumber = this.button.data.phone_number || ''
      this.newLoginUrl = this.button.data.url || ''
      this.newWebviewRatio = this.button.data.webview_height_ratio || 'tall'
      this.newMessengerExtensions = this.button.data.messenger_extensions || false
      this.newFallbackUrl = this.button.data.fallback_url || ''
      this.$emit('popoverOpen')
    },

    setVars() {
      this.button.data.variables = {}
      for (let v in this.blockVariables) {
        let t = null
        if (v.type === 'string') t = ''
        else if (v.type === 'number') t = 0
        else if (v.type === 'boolean') t = true
        this.button.data.variables[v] = t
      }
    },

    saveChanges() {
      let o = {
        text: this.button.text,
        data: this.button.data
      }
      o.uuid = this.button.uuid
      o.text[this.$store.state.flowEditorLocale] = this.newTitle
      o.action = this.newAction
      if (this.newAction === 'url') {
        o.data.url = this.newUrl
        o.data.messenger_extensions = this.newMessengerExtensions
        o.data.webview_height_ratio = this.newWebviewRatio
        if (this.newMessengerExtensions) o.data.fallback_url = this.newFallbackUrl
        else delete o.data.fallback_url
      }
      else if (this.newAction === 'redirect') o.data.target = this.newTarget
      else if (this.newAction === 'postback') o.data.payload = this.newPayload
      else if (this.newAction === 'phone_number') o.data.phone_number = this.newPhoneNumber
      else if (this.newAction === 'account_link') o.data.url = this.newLoginUrl
      this.$set(this, 'button', o)
      this.$emit('change', o)
      this.$refs.popover.doClose()
    },

    buttonTypeChange(newType) {
      if (newType === 'account_link') this.newTitle = this.$t('view.flow.blockElements.button.login')
      else if (newType === 'account_unlink') this.newTitle = this.$t('view.flow.blockElements.button.logout')
    }
  },
  created() {
    this.$set(this, 'button', this.data)
    setTimeout(async () => {
      this.preparePopover()
    }, 0)
  },
  computed: {
    blockVariables: function () {
      const block = this.$store.getters.flowBlock(this.newTarget)
      if (!block) return null
      return block.data.variables
    }
  }
}
</script>

<style lang="scss" scoped>
.message-button {
  @include alignedFlex();
  font-size: 0.96em;
  font-weight: 700;
  border-top: 1px solid $borderGrey;
  height: 30px;
  cursor: pointer;
  background-color: white;

  &:hover {
    background-color: $messageHover;
  }

  &--last {
    border-radius: 0 0 7px 7px;
  }

  &__popover {
    box-shadow: 0 2px 4px rgba(112, 112, 112, 0.12);
    border-radius: 6px;
  }

  &__popover-wrapper {
    padding: 5px 10px 10px 10px;
  }

  &__popover-flex {
    @include alignedFlex(space-between);
    width: 380px;
  }

  &__popover-input {
    width: 180px;
  }

  &__popover-button {
    margin-top: 14px;
  }

  &__popover-data-input {
    width: 100%;
    margin: 10px 0 5px 0;
  }

  &__popover-buttons {
    width: 60%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }

  &__vars {
    text-align: left;
  }

  &__vars-fields {
    @include alignedFlex(flex-start);
    flex-wrap: wrap;
    width: 400px;
  }

  &__vars-field {
    width: 40%;
    margin-right: 10px;
    margin-top: 5px;
  }
}
</style>
